import styled from 'styled-components';

const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  padding: 16px 25px;
  border-radius: 13px;

  background: ${({ $variant }) =>
    $variant === 'outline'
      ? 'rgba(0,0,0,0.10)'
      : 'linear-gradient(135deg, var(--gold), var(--gold-light))'};

  border: 1px solid ${({ $variant }) =>
    $variant === 'outline'
      ? 'rgba(244,197,93,0.72)'
      : 'transparent'};

  color: var(--white);
  font-weight: 950;
  text-transform: uppercase;
  font-size: 0.92rem;
  cursor: pointer;

  box-shadow: ${({ $variant }) =>
    $variant === 'outline'
      ? 'none'
      : '0 16px 34px rgba(221,161,47,0.30)'};

  backdrop-filter: blur(10px);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ $variant }) =>
      $variant === 'outline'
        ? 'none'
        : '0 20px 40px rgba(221,161,47,0.38)'};
    border-color: rgba(244,197,93,1);
  }

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export default Button;